import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { transformStr3, getformListItemsdatas, setformdata, handleHttp, formateDate } from "@/utils/utils";
import flexible from '../../utils/flexible.js';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import guideTheme from '../../components/guideTheme';
import { ImagePreview } from 'vant';
import 'vant/lib/index.css';
export default {
  name: 'guideDetail',
  data() {
    return {
      audioParams: {
        deptId: this.$route.query.fid || '44975',
        formId: '171925',
        page: 1,
        limit: 10,
        searchStr: ''
      },
      detail: {},
      timePass: 0,
      isPlay: false,
      currentTime: '00:00',
      totalTime: '00:00',
      sWidth: 0,
      srcList: [],
      showViewer: false,
      viewIndex: 0
    };
  },
  components: {
    guideTheme
  },
  methods: {
    wrapClick(event, item) {
      const target = event.target;
      if (target.tagName === 'IMG') {
        // console.log(event.target.src)
        event.preventDefault();
        const content = item;
        const imgReg = /<img.*?(?:>|\/>)/gi; // 匹配图片中的img标签
        const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
        const arr = content.match(imgReg); // 筛选出所有的img
        const srcArr = [];
        for (let i = 0; i < arr.length; i++) {
          const src = arr[i].match(srcReg);
          // 获取图片地址
          srcArr.push(src[1]);
        }
        this.srcList = srcArr;
        this.srcList.unshift(event.target.src);
        const set = new Set(this.srcList);
        this.srcList = Array.from(set);
        // this.viewIndex = this.srcList.findIndex((item) =>{return item == event.target.src})
        ImagePreview({
          images: this.srcList,
          showIndex: true,
          loop: false,
          startPosition: 0,
          closeable: true
        });
      }
    },
    closeView() {
      this.showViewer = false;
    },
    barBack() {
      var nowTime = this.$refs.audioItem.currentTime - this.timePass;
      if (nowTime < 0) {
        nowTime = 0;
      }
      this.$refs.audioItem.currentTime = nowTime;
    },
    barPor() {
      var nowTime = this.$refs.audioItem.currentTime + this.timePass;
      if (nowTime > this.$refs.audioItem.duration) {
        nowTime = this.$refs.audioItem.duration;
      }
      this.$refs.audioItem.currentTime = nowTime;
    },
    playAudio() {
      if (this.isPlay) {
        //关闭
        this.$refs.audioItem.pause();
        return this.isPlay = false;
      }
      if (!this.$refs.audioItem.paused) return;
      this.isPlay = true;
      this.$refs.audioItem.play();
    },
    getDuration(audioItem, index) {
      let audio = this.$refs[audioItem];
      if (audio.readyState > 0) {
        let minutes = parseInt(audio.duration / 60, 10);
        let seconds = parseInt(audio.duration % 60);
        minutes = minutes > 9 ? minutes : `0${minutes}`;
        seconds = seconds > 9 ? seconds : `0${seconds}`;
        this.totalTime = minutes + ":" + seconds;
      }
    },
    onTimeupdate() {
      let audio = this.$refs.audioItem;
      var currentTime = audio.currentTime;
      this.currentTime = this.transTime(currentTime);
      this.timePass = audio.duration / 10;
      this.sWidth = currentTime / audio.duration * 100;
    },
    //将时间转换为标准格式
    transTime(time) {
      var duration = parseInt(time);
      var minute = parseInt(duration / 60);
      var sec = duration % 60 + '';
      var isM0 = ':';
      if (minute == 0) {
        minute = '00';
      } else if (minute < 10) {
        minute = '0' + minute;
      }
      if (sec.length == 1) {
        sec = '0' + sec;
      }
      return minute + isM0 + sec;
    },
    getDetailByCode(code) {
      let searchStr = {
        filters: [[{
          compt: "autonumber",
          express: '===',
          alias: "autoCode",
          id: 28,
          range: null,
          val: code
        }]],
        model: 0
      };
      this.audioParams.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearch(this.audioParams).then(res => {
        let formatDataList = res.dataList.map((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
          });
          itemformat.image = itemformat.image.map(img => {
            return `https://museum.chaoxing.com/star3/origin/${img.objectId}.${img.suffix}`;
          });
          item.itemformdata = itemformat;
          return item.itemformdata;
        });
        this.detail = formatDataList[0];
        if (this.detail.audio[0]) {
          this.getAudio(this.detail.audio[0].objectId);
        }
        document.title = this.detail.explainObj;
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperNav, {
            slidesPerView: 'auto',
            centeredSlides: true,
            touchMoveStopPropagation: true,
            runCallbacksOnInit: false,
            observer: true,
            //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,
            loop: true,
            pagination: {
              el: '.slide-pagination'
            }
          });
        });
      });
    },
    // 获取音频
    getAudio(objectId) {
      this.$api.getUrlByObjectId(objectId).then(res => {
        this.detail.audioUrl = res.http;
      });
    }
  },
  created() {
    flexible();
    this.getDetailByCode(this.$route.query.aCode);
  },
  computed: {
    guideThemeColor() {
      return this.$store.state.guideTheme.color;
    }
  }
};